import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

export function useDeleteNonSavedTreatmentPlanMutation(options = {}) {
  return useMutation((dto) => {
    return http.delete(HTTP_ENDPOINTS.deleteNonSavedTreatmentPlan(dto.planId));
  }, options);
}
